import script from "./GaugeTelemetry.vue?vue&type=script&setup=true&lang=js"
export * from "./GaugeTelemetry.vue?vue&type=script&setup=true&lang=js"

import "./GaugeTelemetry.vue?vue&type=style&index=0&id=41f2739d&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/set-repository-web-glasses/glasses-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41f2739d"]])

export default __exports__